/* eslint-disable sonarjs/cognitive-complexity */
import { createSelector } from 'reselect';
import CARTPAGE_CONSTANTS from '../../../CartItemTile.constants';
import {
  getCartOrderList,
  getOrderShipments,
  getProductOrderItemType,
  getProductShipmentId,
  getProductQty,
} from '../../../container/CartItemTile.selectors';

const { ECOM, BOPIS, BOSS, AVAILABILITY_UNAVAILABLE } = CARTPAGE_CONSTANTS;

export const getShipmentItems = (shipmentItemsObject, shipmentId, product) => {
  const existingItems = shipmentItemsObject[shipmentId];
  let items = [product];
  if (existingItems && existingItems.length > 0) {
    items = [...existingItems, ...items];
  }
  return items;
};

export const getShipment = (shipmentId, orderShipments) => {
  const convertedShipment = orderShipments?.map((item) => {
    const myShipment = JSON.stringify(item);
    return JSON.parse(myShipment);
  });
  return convertedShipment.find((shipment) => shipment?.shipmentId === shipmentId);
};

const getShipmentGroupedItems = (shipmentItemsObject, orderType, orderShipments) => {
  const groupedItems = [];
  if (Object.keys(shipmentItemsObject).length > 0) {
    Object.keys(shipmentItemsObject).forEach((key) => {
      groupedItems.push({
        orderType,
        shipmentId: key,
        shipment: getShipment(key, orderShipments),
        items: shipmentItemsObject[key],
      });
    });
  }
  return groupedItems;
};

export const mobileAppConditions = (productDetail) => {
  return (
    productDetail?.miscInfo?.bossStartDate &&
    Object.keys(productDetail?.miscInfo?.bossStartDate).length > 0 &&
    productDetail?.miscInfo?.bossEndDate &&
    Object.keys(productDetail?.miscInfo?.bossEndDate).length > 0
  );
};

export const getGroupItemsQty = (groupedItem) => {
  let itemsQty = 0;
  const { items = [] } = groupedItem || {};
  items.forEach((item) => {
    itemsQty += getProductQty(item);
  });
  return itemsQty;
};

export const getTotalItemsQty = (groupedItems) => {
  let totalItemsCount = 0;
  groupedItems.forEach((groupedItem) => {
    totalItemsCount += getGroupItemsQty(groupedItem);
  });
  return totalItemsCount;
};

export const getIsUnavailable = (availabililty, orderItemType, isBossEligible) => {
  return availabililty === AVAILABILITY_UNAVAILABLE || (orderItemType === BOSS && !isBossEligible);
};

const getGroupedItems = createSelector(
  getCartOrderList,
  getOrderShipments,
  (orderItems, orderShipments) => {
    let groupedItems = [];
    const shippingItems = [];
    const bopisItemsObject = {};
    const bossItemsObject = {};

    if (!orderItems || orderItems.size === 0) {
      return groupedItems;
    }
    if (orderItems) {
      orderItems.forEach((element) => {
        const itemType = getProductOrderItemType(element).toLowerCase();
        const shipmentId = getProductShipmentId(element);

        if (itemType === BOPIS.toLowerCase()) {
          bopisItemsObject[shipmentId] = getShipmentItems(bopisItemsObject, shipmentId, element);
        } else if (itemType === BOSS.toLowerCase()) {
          bossItemsObject[shipmentId] = getShipmentItems(bossItemsObject, shipmentId, element);
        } else {
          shippingItems.push(element);
        }
      });

      if (shippingItems.length > 0) {
        groupedItems.push({
          orderType: ECOM,
          items: shippingItems,
          shipmentId: getProductShipmentId(shippingItems[0]),
        });
      }

      const bopisGroupedItems = getShipmentGroupedItems(bopisItemsObject, BOPIS, orderShipments);
      if (bopisGroupedItems.length > 0) {
        groupedItems = [...groupedItems, ...bopisGroupedItems];
      }

      const bossGroupedItems = getShipmentGroupedItems(bossItemsObject, BOSS, orderShipments);
      if (bossGroupedItems.length > 0) {
        groupedItems = [...groupedItems, ...bossGroupedItems];
      }

      return groupedItems;
    }
    return null;
  }
);

export default getGroupedItems;
